const CLEAR_ERRORS = 'app/errors/CLEAR_ERRORS'

export { CLEAR_ERRORS }
